export { NewsSection } from './NewsSection';
